<template>
  <audit-log
    :rule-id="ruleId"
    :transaction-type="transactionType"
  />
</template>

<script>
  export default {
    name: 'RuleAuditLog',

    components: {
      AuditLog: () => import('../components/AuditLog'),
    },

    props: {
      ruleId: String,
      transactionType: String,
    },
  }
</script>
